import About from "./About/About";
import "./App.css";

import {
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
} from "react-router-dom";

import { useState } from "react";
import { FaArrowUp } from "react-icons/fa";
import ScrollToTop from "react-scroll-to-top";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoadingBar from "react-top-loading-bar";
import CompanyInfo from "./CompanyInfo";
import ScrollToTopRef from "./components/ScrollToTop";
import ContactFull from "./ContactFull/ContactFull";
import UpdatedNavbar from "./NavBar/UpdatedNavbar";
import UpdatedFooter from "./NewFooter/UpdatedFooter";
import PageNotFound from "./PageNotFound";
import ServicesTechnologies from "./pages/ServicesTechnologies";
import PlanDemoPage from "./PlansAndPackage/PlanDemoPage";
import PlanPage from "./PlansAndPackage/PlanPage";
import Projects from "./Projects/Projects";
import Technologies from "./Technologies/Technologies";
import DemoPage from "./UpdatedDesignPackage/DemoPage";
import DesignPage from "./UpdatedDesignPackage/DesignPage";
import Home from "./UpdatedHome/Home";
import Services from "./UpdatedService/Services";
import StartProject from "./UpdatedStartProject/StartProject";
import TermsAndConditions from "./components/TermsAndConditions";
import PrivacyPolicy from "./components/PrivacyPolicy";
import ClientTestimonials from "./ClientTestimonialsPage/ClientTestimonials";
import Blogs from "./Blogs/Blogs";
import BlogDetail from "./Blogs/BlogDetail";

const AppContent = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const visitSoftwareHub = queryParams.get("visit-software-hub");

  // Log the query parameters for debugging
  console.log("Query Params:", queryParams.toString());
  console.log("Visit Software Hub:", visitSoftwareHub);

  // Render CompanyInfo if the parameter is present, regardless of its value
  if (visitSoftwareHub !== null) {
    return <CompanyInfo />;
  } else {
    return <Home />;
  }
};

function App() {
  const [progress, setProgress] = useState(0);

  return (
    <div className="App">
      <ScrollToTop
        smooth
        top={300}
        component={<FaArrowUp className="uiq-scroll-icon" />}
        className="uiq-scroll-to-top"
      />
      <Router>
        <ScrollToTopRef />
        <LoadingBar
          color="#f11946"
          progress={progress}
          onLoaderFinished={() => setProgress(0)}
        />
        {/* <Navbar /> */}
        <UpdatedNavbar />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        <Routes>
          <Route path="/" element={<AppContent />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<ContactFull />} />
          <Route path="/project" element={<Projects />} />
          <Route path="/services" element={<Services />} />

          <Route path="/visit-software-hub" element={<CompanyInfo />} />
          <Route path="/start-project" element={<StartProject />} />
          <Route path="/design" element={<DesignPage />} />
          <Route path="/plans-pricing" element={<PlanPage />} />
          {/* <Route path="add-design" element={<AddDesignPackageForm />} /> */}
          {/* <Route path="add-plans" element={<AddPlanPackageForm />} /> */}
          <Route path="/design/:id/:packagename" element={<DemoPage />} />
          <Route
            path="/plans-pricing/:id/:packagename"
            element={<PlanDemoPage />}
          />
          <Route
            path="/services-technologies"
            element={<ServicesTechnologies />}
          />
          <Route path="/technologies" element={<Technologies />} />
          <Route
            path="/terms-and-conditions"
            element={<TermsAndConditions />}
          />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/testimonials" element={<ClientTestimonials />} />

          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blogs/:slug" element={<BlogDetail />} />

          <Route path="*" element={<PageNotFound />} />
        </Routes>
        <UpdatedFooter />
      </Router>
    </div>
  );
}

export default App;

// Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyBw8VlMhcYuaESDeZ20ZRrAjXUWuNG3xEE",
//   authDomain: "oglitz-software.firebaseapp.com",
//   projectId: "oglitz-software",
//   storageBucket: "oglitz-software.appspot.com",
//   messagingSenderId: "875317218028",
//   appId: "1:875317218028:web:70318ffee89338db90b3c9",
//   measurementId: "G-6P821JZN4B"
// };

// Initialize Firebase
// const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
